module.exports = __webpack_public_path__ + "static/media/downloadApple.c06b5f5e.svg";